/* eslint react/require-default-props: 0 */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import { get, omit } from 'lodash';

import Link from 'react-router/lib/Link';
import Popup from '../common/Popup';
import TermsContent from './TermsContent';
import { AUTH, COMMON, DIALOG_TITLE } from '../../constants/strings';
import { SPACE } from '../../constants/chars';
import {
  privacyListSelector,
  sendingPrivacySelector,
} from '../../redux/data/selectors';
import { actions as popupActions } from '../../redux/ui/popup';
import styles from './index.styl';

const mapStateToProps = state => ({
  privacyList: privacyListSelector(state),
  sending: sendingPrivacySelector(state),
});

const mapDispatchToProps = {
  toggleContent: popupActions.toggleContent,
};

@injectIntl
@connect(
  mapStateToProps,
  mapDispatchToProps,
)
@CSSModules(styles, { allowMultiple: true })
export default class TermsAndConditions extends PureComponent {
  static propTypes = {
    acceptable: PropTypes.bool,
    className: PropTypes.string,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func,
    }),
    privacyList: PropTypes.array,
    country: PropTypes.string,
    sending: PropTypes.bool,
    hasSeparator: PropTypes.bool,
    onSelect: PropTypes.func,
    toggleContent: PropTypes.func,
    secondaryContent: PropTypes.bool,
    additionalStyles: PropTypes.string,
  };

  state = {
    termsAndConditionsIsVisible: false,
    type: '',
  };

  componentWillMount() {
    this.handleCloseBounded = this.handleClose.bind(this);
    this.handleTermsAndConditionsBtnClickBounded = this.handleTermsAndConditionsBtnClick.bind(
      this,
    );
  }

  handlePrivacyText = country => {
    const { sending, privacyList } = this.props;
    return (
      !sending && privacyList.find(item => get(item, 'country') === country)
    );
  };

  handleClose(termsAndConditionsIsVisible) {
    this.setState({ termsAndConditionsIsVisible });
  }

  handleTermsAndConditionsBtnClick(e, type) {
    const { toggleContent, secondaryContent } = this.props;

    e.preventDefault();
    e.stopPropagation();

    this.setState(prevState => {
      if (secondaryContent) toggleContent();
      return {
        termsAndConditionsIsVisible: !prevState.termsAndConditionsIsVisible,
        type,
      };
    });
  }

  handleClosePopup = e => {
    const { toggleContent, secondaryContent } = this.props;

    e.preventDefault();
    e.stopPropagation();

    if (secondaryContent) toggleContent();
    this.handleCloseBounded(false);
  };

  render() {
    const {
      acceptable,
      className,
      intl: { formatMessage },
      country,
      hasSeparator,
      onSelect = () => {},
      toggleContent,
      secondaryContent,
      additionalStyles,
      ...other
    } = this.props;

    const { type, termsAndConditionsIsVisible } = this.state;
    const defaultPrivacy = this.handlePrivacyText('USA');
    // TODO temporary privacyList contain only USA
    const privacyText = defaultPrivacy;
    return (
      <div
        {...{ className }}
        {...omit(other, ['dispatch', 'privacyList', 'sending'])}
      >
        <div styleName="checkboxWrapper">
          <If condition={acceptable}>
            <input
              className="mr2"
              id="acceptedPrivacyPolicy"
              name="acceptedPrivacyPolicy"
              value
              type="checkbox"
              key={country}
              onChange={e => onSelect(e.target.checked)}
            />
          </If>
          <div className={additionalStyles}>
            {acceptable && <FormattedMessage {...AUTH.actions.tnc.textTitle} />}
            {SPACE}
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <Link
              children={AUTH.actions.tnc.textLink}
              onClick={e =>
                this.handleTermsAndConditionsBtnClickBounded(e, 'privacy')
              }
              className=" ml1 mr2 dib"
              styleName={classNames('link', {
                'link--acceptable': acceptable,
              })}
            >
              <FormattedMessage {...COMMON.privacy} />
            </Link>
            {hasSeparator && (
              <span styleName="text" className="mr2 dib">
                {formatMessage(DIALOG_TITLE.and)}
              </span>
            )}
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <Link
              children={AUTH.actions.tnc.textLink}
              onClick={e =>
                this.handleTermsAndConditionsBtnClickBounded(e, 'terms')
              }
              styleName={classNames('link', {
                'link--acceptable': acceptable,
              })}
            >
              <FormattedMessage {...AUTH.actions.tnc.textLink} />
            </Link>
          </div>
        </div>
        <Popup
          opened={termsAndConditionsIsVisible}
          onClose={this.handleClosePopup}
          title={
            type === 'terms'
              ? formatMessage(COMMON.terms)
              : formatMessage(COMMON.privacy)
          }
          width="medium"
        >
          <TermsContent
            content={
              type === 'terms' ? privacyText.terms : privacyText.privacyPolicy
            }
          />
        </Popup>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TermsAndConditions/index.jsx